import React from 'react';
import {useSelector} from "react-redux";
import {useQuery} from "@tanstack/react-query";
import {secretApi} from "../../../api/api";
import {getDataDragonRegion} from "../../../i18n/languages";

const UseLlmTips = ({champion_id,enemy_champion_id}) => {

    const currentLang = useSelector((state) => state?.translation.lang);
    const query = useQuery({
        queryKey: ['llmTips', champion_id, enemy_champion_id,currentLang],
        staleTime: Infinity,
        queryFn: async () => {
            if (!champion_id || !enemy_champion_id) {
                return {}
            }
            const tips = await llmTips({champion_id, enemy_champion_id,language:currentLang})
            return { tips: tips};
        },
        placeholderData: {
            tips: {
                levelAdvantage: {},
                tips: [],
            }
        },
    })
    return query

};
const llmTips = async ({champion_id, enemy_champion_id,language}) => {
    try {
        const url = new URL(`${process.env.REACT_APP_CACHE_API}matchup/matchup_tips`);
        url.searchParams.set('champion_id', champion_id);
        url.searchParams.set('enemy_champion_id', enemy_champion_id);
        url.searchParams.set('language',getDataDragonRegion(language))
        const result = await secretApi.get(url.toString())
        return result.data;
    } catch (e) {
        return [];
    }
}

export default UseLlmTips;